import {
  BrowserCacheLocation,
  Configuration,
  RedirectRequest,
  LogLevel,
} from "@azure/msal-browser";

// Browser check variables
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;

// MSAL Configuration
export const msalConfigAdfs: Configuration = {
  auth: {
    clientId: "38abe0f9-222c-4b4e-adb7-3592af700a26",
    //authority: "https://adfs.emrelab.na.xom.com/adfs/",
    authority: "https://adfs.rsch.lablan.local/adfs/",
    redirectUri: window.location.origin,
    knownAuthorities: ["https://adfs.rsch.lablan.local/adfs/"],
    //knownAuthorities: ["https://adfs.emrelab.na.xom.com/adfs/"], // Required for ADFS
  },
  cache: {
    storeAuthStateInCookie: isIE || isEdge, // Use cookies for legacy browser compatibility
    cacheLocation: BrowserCacheLocation.LocalStorage, // Store tokens in localStorage
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (!containsPii) {
          console.log(`[MSAL][${LogLevel[level]}]: ${message}`);
        }
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
};

// Example request configuration for accessing MS Graph.
export const graphLoginRequest: RedirectRequest = {
  scopes: ["https://graph.microsoft.com/User.Read"],
  domainHint: "exxonmobil.com",
};

// Place any scopes required by your app here
export const appLoginRequestAdfs: RedirectRequest = {
  scopes: [],
  domainHint: "exxonmobil.com",
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

/**
 * Note: Configuration for scopes, api endpoints and client ids can be
 * configured in whichever way feels the most natural and accessible way
 *  for you and your applications use-case. Please feel free to abstract them
 *  away from this file in whichever way you see fit.
 */
